import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { OAuthStore } from './oauth.store';
import { isOAuthEnabled } from './oauth.config';

@Component({
  selector: 'app-signin-callback',
  standalone: true,
  imports: [MatProgressSpinnerModule, MatIconModule, MatButtonModule],
  template: `
    <div class="callback-container">
      <!-- Present from the start, so the switch from loading to error is announced -->
      <p class="error-message" role="alert">
        @if (oauthStore.hasError()) {
          {{ oauthStore.error() }}
        }
      </p>
      @if (oauthStore.hasError()) {
        <mat-icon class="error-icon" aria-hidden="true">error</mat-icon>
        <button mat-button (click)="goToLogin()">Zurück zur Anmeldung</button>
      } @else {
        <mat-spinner diameter="48"></mat-spinner>
        <p class="message">Anmeldung wird verarbeitet...</p>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .callback-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        gap: 1rem;
        background: var(--md-sys-color-surface);
        color: var(--md-sys-color-on-surface);
      }

      .message {
        font-size: 1rem;
        color: var(--md-sys-color-on-surface-variant);
      }

      .error-icon {
        order: -1;
        font-size: 3rem;
        width: 3rem;
        height: 3rem;
        color: var(--md-sys-color-error);
      }

      .error-message {
        font-size: 1rem;
        color: var(--md-sys-color-error);
        text-align: center;
        max-width: 20rem;
      }

      // Empty live region stays in the DOM but out of the layout
      .error-message:empty {
        position: absolute;
      }
    `,
  ],
})
export class SigninCallbackComponent implements OnInit {
  private readonly router = inject(Router);
  protected readonly oauthStore = inject(OAuthStore);

  ngOnInit(): void {
    if (!isOAuthEnabled()) {
      this.router.navigate(['/']);
      return;
    }
    this.oauthStore.initialize();
  }

  protected goToLogin(): void {
    this.oauthStore.clearError();
    this.router.navigate(['/']);
  }
}
